import React, { useState } from "react";
import { Link } from "gatsby";
import { categoryParams } from "../../../node-category";
import IconTous from "../../assets/icons/menu/tous.svg";
import IconToteBag from "../../assets/icons/menu/tote-bag.svg";
import IconToteBagBio from "../../assets/icons/menu/tote-bag-bio.svg";
import IconToteBagXxl from "../../assets/icons/menu/tote-bag-xxl.svg";
import IconCabas from "../../assets/icons/menu/cabas.svg";
import IconToileDeJute from "../../assets/icons/menu/toile-de-jute.svg";
import IconSacADos from "../../assets/icons/menu/sac-a-dos.svg";
import IconPochon from "../../assets/icons/menu/pochon.svg";
import IconTrousse from "../../assets/icons/menu/trousse.svg";

const Nav = ({ showMenu, closeMenu }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleItem = (index) => {
    setExpandedIndex(newval => newval === index ? null : index);
  };

  const links = [
    {
      url: `#`,
      label: "Tote Bags",
      items: [
        { url: `${categoryParams.urlPrefix}tote-bags-personnalises/`, label: "Tote bags personnalisés", Icon: IconToteBag },
        { url: `${categoryParams.urlPrefix}tote-bags-personnalises-coton-biologique/`, label: "Tote bags personnalisés biologiques", Icon: IconToteBagBio },
        { url: `${categoryParams.urlPrefix}tote-bags-grand-format-xxl-personnalises/`, label: "Tote bags personnalisés grand format", Icon: IconToteBagXxl },
        // { url: `${categoryParams.urlPrefix}sacs-coton-ecologique-personnalises/`, label: "Tote bags personnalisés écologiques" }
      ]
    },
    {
      url: `#`,
      label: "Cabas",
      items: [
        { url: `${categoryParams.urlPrefix}cabas-personnalises/`, label: "Sacs cabas personnalisés", Icon: IconCabas },
        { url: `${categoryParams.urlPrefix}sacs-en-toile-de-jute-personnalises/`, label: "Sacs en toile de jute personnalisés", Icon: IconToileDeJute },
        { url: `${categoryParams.urlPrefix}sac-a-dos-personnalise-publicitaire/`, label: "Sacs à dos publicitaire personnalisés", Icon: IconSacADos },
        // { url: `${categoryParams.urlPrefix}sac-de-sport-personnalise-publicitaire/`, label: "Sacs de sport publicitaire personnalisés" },
        // { url: `${categoryParams.urlPrefix}sac-a-pain-tissu-personnalise-publicitaire/`, label: "Sacs à pain publicitaire personnalisés" },
        // { url: `${categoryParams.urlPrefix}sac-tissu-personnalise-publicitaire/`, label: "Tous nos sacs en tissu personnalisés" },
      ]
    },
    {
      url: `#`,
      label: "Pochettes",
      items: [
        { url: `${categoryParams.urlPrefix}pochettes-personnalisees/`, label: "Pochettes personnalisées", Icon: IconPochon },
        { url: `${categoryParams.urlPrefix}trousses-personnalisees/`, label: "Trousses personnalisées", Icon: IconTrousse }
      ]
    },
    // {
    //   url: `${categoryParams.urlPrefix}tote-bags-francais-personnalises/`,
    //   label: "Tote bags Français",
    // },
    {
      url: '#',
      label: "Tote bags Français",
      items: [
        { url: `${categoryParams.urlPrefix}sacs-coton-made-in-france`, label: `Tous les produits Made in France`, Icon: IconTous },
        { url: `${categoryParams.urlPrefix}tote-bags-francais-personnalises`, label: `Tote bags personnalisés`, Icon: IconToteBag },
        { url: `${categoryParams.urlPrefix}sacs-cabas-publicitaires-personnalisees-made-in-france`, label: `Sacs cabas personnalisés`, Icon: IconCabas },
        { url: `${categoryParams.urlPrefix}pochons-publicitaires-personnalisees-made-in-france`, label: `Pochons personnalisés`, Icon: IconPochon },
        { url: `${categoryParams.urlPrefix}trousses-publicitaires-personnalisees-made-in-france`, label: `Trousses personnalisées`, Icon: IconTrousse },
      ]
    },
    {
      url: `/categorie-produit/textiles-personnalises`,
      label: "Textiles",
    },
    {
      url: `/tote-bag-sur-mesure/`,
      label: "Fabrication spéciale",
    }
  ];

  return <nav id="main-nav" className={`flex px-0 ${showMenu ? 'showMenu' : 'hidden'} `}>
    <ul className="flex space-x-2 space-y-8 lg:space-y-0 lg:justify-between items-center">
      <li className="lg:hidden w-full flex justify-start items-center py-4 absolute top-0 left-4">
        <button type="button" className="bg-transparent border-2 border-white rounded-full w-12 h-12 text-white font-bold text-xl flex items-center justify-center hover:bg-white hover:text-blue transition-colors" onClick={closeMenu}>X</button>
      </li>
      <li className="lg:hidden w-full text-center mt-4">
        <Link
          to="/contacter-l-atelier-du-tote-bag"
          onClick={closeMenu}
          className="inline-block bg-blue-hover text-white rounded-md font-bold uppercase text-sm px-6 py-3 hover:bg-blue-light transition-colors"
        >
          Demandez un devis
        </Link>
      </li>
      {links.map((link, i) => (
        <li key={i} className="w-full lg:w-auto">
          {link.items && (
            <div className="group relative flex flex-col">
              <span
                className="cursor-pointer flex items-center justify-center lg:justify-start relative"
              >
                {link.label}
                <span className="lg:hidden ml-2 text-xl">{expandedIndex === i ? '−' : '+'}</span>
                <span
                  onClick={() => toggleItem(i)}
                  className="absolute top-0 left-0 w-full h-full cursor-pointer"
                >&nbsp;</span>
              </span>
              <ul
                className={`lg:hidden lg:group-hover:block subMenu top-5 transition-all duration-300 overflow-hidden ${expandedIndex === i ? '' : 'max-h-0 opacity-0'} lg:group-hover:max-h-96 lg:group-hover:opacity-100`}
              >
                {link.items.map((item, j) => (
                  <li key={j} className="group/item">
                    <Link className="lg:group-hover/item:text-white" onClick={closeMenu} to={item.url}>
                      {item.Icon && <item.Icon className="inline-block align-middle w-5 h-5 mr-2" aria-hidden="true" />}
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {!link.items && (
            <Link to={link.url} onClick={closeMenu} className="group relative flex flex-col ">{link.label}</Link>
          )}
          {/* TOTEBAG FR */}
          {i === 3 && (<div className="hidden lg:flex">
            <div className="flex-1 h-1 bg-blue"></div>
            <div className="flex-1 h-1 bg-white"></div>
            <div className="flex-1 h-1 bg-red-danger"></div>
          </div>)}
        </li>
      ))}

      <li className="hidden lg:block lg:ml-auto">
        <Link
          to="/contacter-l-atelier-du-tote-bag"
          className="inline-block bg-orange !text-white !font-normal uppercase text-sm px-4 py-1 rounded-3xl hover:bg-gray-200 hover:!text-blue transition-colors mb-2"
        >
          Demandez un devis
        </Link>
      </li>
    </ul>
  </nav>
};

export default Nav;
